<div class="content-container">
  <div class="bordered-container">
    <h2 class="section-title">Drukwerk detail</h2>

    <div class="grid-container">
      <!-- Product Type -->
      <div class="grid-item">
        <label for="type" [class.disabled]="localPrintProduction.linkedToSign"
          >Type *</label
        >
        <mat-form-field appearance="outline">
          <mat-select
            id="type"
            placeholder="Selecteer type"
            [(ngModel)]="localPrintProduction.type"
            (ngModelChange)="validateFields()"
            (selectionChange)="onTypeChange()"
            [disabled]="localPrintProduction.linkedToSign"
            required
          >
            <mat-option [value]="null"> - leeg -</mat-option>
            <mat-option
              *ngFor="let option of printProductTypeChoices"
              [value]="option.key"
            >
              {{ option.value }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="!localPrintProduction.type">
            Type is verplicht.
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Subtype -->
      <div class="grid-item">
        <label
          for="subType"
          [class.disabled]="
            isSubTypeDisabled || localPrintProduction.linkedToSign
          "
          >Subtype</label
        >
        <mat-form-field appearance="outline">
          <mat-select
            id="subType"
            placeholder="Selecteer subtype"
            [(ngModel)]="localPrintProduction.subType"
            (ngModelChange)="validateFields()"
            (selectionChange)="onSubTypeChange()"
            [disabled]="isSubTypeDisabled || localPrintProduction.linkedToSign"
          >
            <mat-option [value]="null"> - leeg -</mat-option>
            <mat-option
              *ngFor="let option of subTypeChoices"
              [value]="option.key"
            >
              {{ option.value }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- subType Comment -->
      <div
        class="grid-item"
        style="grid-column: span 2"
        *ngIf="isShowSubTypeComment"
      >
        <label for="subTypeComment">Opmerking subtype</label>
        <mat-form-field appearance="outline">
          <input
            id="subTypeComment"
            matInput
            [(ngModel)]="localPrintProduction.subTypeComment"
            [disabled]="localPrintProduction.linkedToSign"
          />
        </mat-form-field>
      </div>

      <!-- Print Method -->
      <div class="grid-item">
        <label
          for="printMethod"
          [class.disabled]="
            isPrintMethodDisabled || localPrintProduction.linkedToSign
          "
          >Drukwijze *</label
        >
        <mat-form-field appearance="outline">
          <mat-select
            id="printMethod"
            placeholder="Selecteer drukwijze"
            [(ngModel)]="localPrintProduction.printMethod"
            (ngModelChange)="validateFields()"
            (selectionChange)="onPrintMethodChange()"
            [disabled]="
              isPrintMethodDisabled || localPrintProduction.linkedToSign
            "
            required
          >
            <mat-option [value]="null"> - leeg -</mat-option>
            <mat-option
              *ngFor="let option of printMethodTypeChoices"
              [value]="option.key"
            >
              {{ option.value }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="!localPrintProduction.printMethod">
            Drukwijze is verplicht.
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Material -->
      <div class="grid-item">
        <label
          for="material"
          [class.disabled]="
            isMaterialsDisabled || localPrintProduction.linkedToSign
          "
          >Materiaal *</label
        >
        <mat-form-field appearance="outline">
          <mat-select
            id="material"
            placeholder="Selecteer materiaal"
            [(ngModel)]="localPrintProduction.material"
            (ngModelChange)="validateFields()"
            (selectionChange)="onMaterialChange()"
            required
            [disabled]="
              isMaterialsDisabled || localPrintProduction.linkedToSign
            "
          >
            <mat-option [value]="null"> - leeg -</mat-option>
            <mat-option
              *ngFor="let option of materialOptions"
              [value]="option.key"
            >
              {{ option.value }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="!localPrintProduction.material">
            Materiaal is verplicht.
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Material Comment -->
      <div
        class="grid-item"
        style="grid-column: span 2"
        *ngIf="isShowMaterialComment"
      >
        <label for="materialComment">Opmerking materiaal</label>
        <mat-form-field appearance="outline">
          <input
            id="materialComment"
            matInput
            [(ngModel)]="localPrintProduction.otherMaterialComment"
            [disabled]="localPrintProduction.linkedToSign"
          />
        </mat-form-field>
      </div>

      <!-- Number of Colors -->
      <div class="grid-item">
        <label
          for="nbColors"
          [class.disabled]="
            isPrintColorsDisabled || localPrintProduction.linkedToSign
          "
          >Aantal kleuren *</label
        >
        <mat-form-field appearance="outline">
          <mat-select
            id="nbColors"
            placeholder="Selecteer kleuren"
            [(ngModel)]="localPrintProduction.nbColors"
            (ngModelChange)="validateFields()"
            required
            [disabled]="
              isPrintColorsDisabled || localPrintProduction.linkedToSign
            "
          >
            <mat-option [value]="null"> - leeg -</mat-option>
            <mat-option
              *ngFor="let option of nbColorsTypeChoices"
              [value]="option.key"
            >
              {{ option.value }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="!localPrintProduction.nbColors">
            Aantal kleuren is verplicht.
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Secondary Number of Colors -->
      <div class="grid-item" *ngIf="isShowSecondaryColours">
        <label for="secondaryNbColors" class="disabled">Kleur digitaal</label>
        <mat-form-field appearance="outline">
          <mat-select
            id="secondaryNbColors"
            [(ngModel)]="defaultSecondaryColorOption"
            disabled
          >
            <mat-option [value]="'CYMK'">{{ NbColorsType.CMYK }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!-- empty dive so dimensions field dont move up when secondaryNbColors field is not displayed-->
      <div *ngIf="!isShowSecondaryColours"></div>

      <!-- Dimensions -->
      <div class="grid-item">
        <label
          for="dimensions"
          [class.disabled]="
            isDimensionsDisabled || localPrintProduction.linkedToSign
          "
          >Afmetingen *</label
        >
        <mat-form-field appearance="outline">
          <mat-select
            id="dimensions"
            placeholder="Selecteer afmeting"
            [(ngModel)]="localPrintProduction.dimensions"
            (ngModelChange)="validateFields()"
            (selectionChange)="onDimensionsChange()"
            required
            [disabled]="
              isDimensionsDisabled || localPrintProduction.linkedToSign
            "
          >
            <mat-option [value]="null"> - leeg -</mat-option>
            <mat-option
              *ngFor="let option of dimensionOptions"
              [value]="option.key"
            >
              {{ option.value }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="!localPrintProduction.dimensions">
            Afmetingen zijn verplicht.
          </mat-error>
        </mat-form-field>
      </div>

      <div class="grid-item"></div>

      <!-- Custom Width -->
      <div class="grid-item" *ngIf="!isCustomDimensionsDisabled">
        <label
          for="width"
          [class.disabled]="
            isCustomDimensionsDisabled || localPrintProduction.linkedToSign
          "
          >Custom Breedte *</label
        >
        <mat-form-field appearance="outline">
          <input
            id="width"
            type="number"
            matInput
            [(ngModel)]="localPrintProduction.customDimensions.width"
            [disabled]="
              isCustomDimensionsDisabled || localPrintProduction.linkedToSign
            "
            (ngModelChange)="validateFields()"
          />
        </mat-form-field>
      </div>

      <!-- Custom Height -->
      <div class="grid-item" *ngIf="!isCustomDimensionsDisabled">
        <label
          for="height"
          [class.disabled]="
            isCustomDimensionsDisabled || localPrintProduction.linkedToSign
          "
          >Custom Hoogte *</label
        >
        <mat-form-field appearance="outline">
          <input
            id="height"
            type="number"
            matInput
            [(ngModel)]="localPrintProduction.customDimensions.height"
            [disabled]="isCustomDimensionsDisabled"
            (ngModelChange)="validateFields()"
          />
        </mat-form-field>
      </div>

      <!-- Dimensions Comment -->
      <div
        class="grid-item"
        style="grid-column: span 2"
        *ngIf="isShowDimensionsComment"
      >
        <label for="dimensionsComment">Opmerking afmeting</label>
        <mat-form-field appearance="outline">
          <input
            id="dimensionsComment"
            matInput
            [(ngModel)]="localPrintProduction.dimensionsComment"
            [disabled]="localPrintProduction.linkedToSign"
          />
        </mat-form-field>
      </div>

      <!-- Film Cost -->
      <div class="grid-item">
        <label for="filmCost" [class.disabled]="isFilmcostDisabled"
          >Filmkost</label
        >
        <mat-form-field appearance="outline">
          <mat-icon matPrefix>euro_symbol</mat-icon>
          <input
            id="filmCost"
            type="number"
            matInput
            [(ngModel)]="localPrintProduction.filmCost"
            [disabled]="isFilmcostDisabled"
          />
        </mat-form-field>
      </div>

      <!-- Sieve Change -->
      <div class="grid-item">
        <label for="sieveChange" [class.disabled]="isSieveChangeDisabled"
          >Zeefwissel(st)</label
        >
        <mat-form-field appearance="outline">
          <mat-icon matPrefix>euro_symbol</mat-icon>
          <input
            id="sieveChange"
            type="number"
            matInput
            [(ngModel)]="localPrintProduction.sieveChange"
            [disabled]="isSieveChangeDisabled"
          />
        </mat-form-field>
      </div>
    </div>
  </div>

  <!-- Prices Section -->
  <div class="bordered-container">
    <h2 class="section-title">Prijzen</h2>
    <app-price-table
      [(bulkPrices)]="localPrintProduction.bulkPrices"
    ></app-price-table>
  </div>

  <div class="bordered-container">
    <h2 class="section-title">Extra info</h2>
    <div class="grid-container">
      <div style="grid-column: span 2">
        <mat-form-field appearance="outline" style="width: 100%">
          <textarea
            id="extraInfo"
            matInput
            placeholder="..."
            rows="3"
            style="resize: none"
            [(ngModel)]="localPrintProduction.extraInfo"
          ></textarea>
        </mat-form-field>
      </div>
    </div>
  </div>

  <!-- Save Button with validation check -->
  <div class="confirm-container border-top mr-4">
    <button
      class="btn button"
      type="button"
      (click)="save()"
      [disabled]="!isFormValid"
    >
      <span>Save</span>
    </button>
  </div>
</div>
